<template>


  <b-row align-h="center" class="d-flex flex-column flex-grow-1 py-3" style="height: 100%">

    <b-modal id="modal-waiverSubmitted" centered size="md" v-bind:hide-footer="true" title="Waiver Submitted">

      Waiver submitted succesfully. Please ask front desk to onboard your team for gamebay.

    </b-modal>  

    <!-- modal review page -->
    <b-modal id="modal-reviewAndAgree" scrollable centered size="lg" v-bind:hide-footer="true" title="Review & Agree">
      <p class="h7">
        {{waiverParagraph1}}
      </p>
      <p class="h7">
        {{waiverParagraph2}}
      </p>
      <p class="h7">
        {{waiverParagraph3}}
      </p>
      <!-- <p class="h7">
        {{waiverParagraph4}}
      </p>
      <p class="h7">
        {{waiverParagraph5}}
      </p>
      <p class="h7">
        {{waiverParagraph6}}
      </p>
      <p class="h7">
        {{waiverParagraph7}}
      </p> -->
      <p class="h7">
        {{waiverParagraph8}}
      </p>
      <p class="h7">
        {{waiverParagraph9}}
      </p>
      <p class="h7">
        {{waiverParagraph10}}
      </p>
      <p class="h7">
        {{waiverParagraph11}}
      </p>
      <!-- <p class="h7">
        {{waiverParagraph12}}
      </p>
      <p class="h7">
        {{waiverParagraph13}}
      </p> -->
      <!-- <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0 custom-control-lg custom-control custom-checkbox"
            v-model="acceptedCheckBox" :value="1" v-on:change="acceptedWaiverCheckbox"> --> 

      <p>
        <b>
              I have read the above waiver and release and by signing it agree it is my intention to exempt and relieve The Company from liability for personal injury, property damage and/or wrongful death caused by negligence and/or any other cause.
        </b>
      </p>

      </b>
      </b-form-checkbox>
      <br>
      <b-button variant="primary" v-on:click="agreedWaiver()">Agree</b-button>

    </b-modal>

    <b-col class="text-center">
      <b-row class="text-center">
        <b-col></b-col>
        <b-col cols="5"></b-col>
        <!-- <b-col><b-button variant="info" style="color:white;" @click="clickedWaiver()">Mission Waiver</b-button></b-col> -->
      </b-row>
      <br>
      <!-- <router-view></router-view> -->
      <b-row>
        <b-col md="3">
          <p class="questionLabel">FIRST NAME</p>
        </b-col>
        <b-col md="8">
          <b-form-input id="inputField" class="mbInputField inputField" v-model="player_first_name" @keyup="valFirstName();validatePlayerData();"
            type="text" required placeholder="Enter your first name">
          </b-form-input>
          <p v-if="validateFirstName == '1' " class="textValidation">Please enter valid first name</p>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="3">
          <p class="questionLabel">LAST NAME</p>
        </b-col>
        <b-col md="8">
          <b-form-input id="inputField" class="mbInputField inputField" v-model="player_last_name" @keyup="valLastName();validatePlayerData();"
            type="text" required placeholder="Enter your last name">
          </b-form-input>

          <p v-if="validateLastName == '1' " class="textValidation">Please enter valid last name</p>

        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="3">
          <p class="questionLabel">EMAIL-ID</p>
        </b-col>
        <b-col md="8">
          <b-form-input id="inputField" class="mbInputField inputField" v-model="player_email" @keyup="valEmail();validatePlayerData();"
            type="text" required placeholder="Enter your email id">
          </b-form-input>

          <p v-if="validateEmail == '1' " class="textValidation">Please enter valid email id</p>


        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="3">
          <p class="questionLabel">PHONE NUMBER</p>
        </b-col>
        <b-col md="8">
          <b-form-input id="inputField" class="mbInputField inputField" v-model="player_phone" @keyup="valPhone();validatePlayerData();"
            type="text" required placeholder="Enter your phone number">
          </b-form-input>

          <p v-if="validatePhone == '1' " class="textValidation">Please enter valid phone number</p>


        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="3">
          <p class="questionLabel">DATE OF BIRTH</p>
        </b-col>
        <b-col md="8">

          <!-- <b-form-input id="inputField" v-model="player_dob" class="mbInputField" type="date" required size="lg"></b-form-input> -->
          
          <!-- <date-dropdown min="1950-01-01" max="2004-01-01" v-model="selectedDate" /> -->

          <DropdownDatepicker class="btb-datepicker"
            v-bind="formConfig.player_dob.properties"
            v-model="formData.player_dob"
            :defaultDate="formData.player_dob"
          />

        </b-col>
      </b-row>
      <br>
      <hr>
      <br>
      <b-row>
       <!-- <b-col> -->
          <p class="questionLabel">Do you want to add any minors that will play the gamebay?</p>
          <div style="text-align:left;">
            <b-button-group style="width:80%;">

              <b-button variant="outline-primary" @click="minorButtonClicked('yes')" value='yes' class="btnClick: minorsChecked === yes" v-if="validatePlayerField == 0 ">Yes</b-button>
              <b-button variant="outline-primary" value='yes' v-else disabled class="btnClick: minorsChecked === yes">Yes</b-button>


              <b-button variant="outline-primary" @click="minorButtonClicked('no')" value="no" style="margin-left:2%;" v-if="validatePlayerField == 0">No</b-button>
              <b-button variant="outline-primary" value="no" style="margin-left:2%;" v-else disabled>No</b-button>

            </b-button-group>
          </div>
        <!-- </b-col> -->
      </b-row>
      <br>
      <br>

      <!-- begin b-row for minors -->
      <div v-if="minorsChecked == 'yes'">
      <p v-if="validateMinorFirstName == '1' || validateMinorLastName == '1' " class="textValidationMinor">Please enter valid first name or last name</p>
      </div>
      <b-row v-if="minorsChecked == 'yes'" class="questionLabel" v-for="(minordatabase, index) in minorsDetail" :key="index">
        <b-row style="padding-top:3%;">
          <b-col>
            <p>Minor's First Name</p>
          </b-col>

          <b-col>
            <p>Minor's Last Name</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input id="inputField" class="mbInputField inputField" v-model="minordatabase.minors_first_name" v-on:keyup="valMinorFirstName(index)"
              type="text" required placeholder="Minor's first name">
            </b-form-input>
          </b-col>

          <b-col>
            <b-form-input id="inputField" class="mbInputField inputField" v-model="minordatabase.minors_last_name" v-on:keyup="valMinorLastName(index)"
              type="text" required placeholder="Minor's last name">
            </b-form-input>
          </b-col>
        </b-row>
        
        <b-row v-if="minorsChecked == 'yes'" class="questionLabel" style="margin-top:3%;">
          <b-col>
            <p>Date of Birth</p>
          </b-col>

          <b-col>
            <p>Remove Minor</p>
          </b-col>
        </b-row>

        <b-row v-if="minorsChecked == 'yes'">
          <b-col>

            <DropdownDatepicker class="btb-datepicker"
            :state="stateDateOfBirth"
            v-bind="formConfig.minors_date_of_birth"
            v-model="minordatabase.minors_date_of_birth"
            :defaultDate="minordatabase.date_of_birth"
          />

          </b-col>

          <b-col>
            <b-button variant="warning" @click="deleteMinor($event,index)">Delete {{minordatabase.minors_first_name}}</b-button>
          </b-col>

        </b-row>
      </b-row> <!-- closing b-row for the minors -->

      <br>
      <b-row v-if="minorsChecked == 'yes'">
        <hr>
        <b-col>
          <b-button variant="primary" @click="addMinor()" v-if="validateAddMinorButton == '0' ">Add a minor</b-button>
          <b-button variant="primary" @click="addMinor()" v-else disabled>Add a minor</b-button>
        </b-col>
      </b-row>
      <br>

      <b-row v-if="minorsChecked.length > 1">
        <hr>
        <b-button variant="primary" @click="reviewAgree()" style="width:30%;align:center;">Review & Agree</b-button>
      </b-row>
      <br>
      <b-row v-if="acceptedCheckBox == '1'">
        <p class="questionLabel">Please sign below and submit the waiver</p>
        <div class="col-10 mt-2">
          <VueSignaturePad id="signature" ref="signaturePad" :options="{ onBegin, onEnd, signatureoptions }"
            v-show="showSignaturePad" class="signatureClass" />
        </div>

      </b-row>
      <br>
      <b-row v-if="clickedSignature > '0' ">
        <b-col>
          <!-- <b-button variant="success" @click="submitWaiver()" style="color:white;">Submit Waiver</b-button> -->
          <b-button variant="success" @click="submitWaiver()" v-if="validatePlayerField == '0' ">Submit Waiver</b-button>
          <b-button variant="primary" v-else disabled>Don't Submit</b-button>
        </b-col>
      </b-row>

    </b-col>
  </b-row>
</template>

<script src="../dist/vue-date-dropdown.min.js"></script>

<script>

  import moment from 'moment';
  import axios from 'axios';
  // import DateDropdown from 'vue-date-dropdown'; // this for the date dropdown
  import DropdownDatepicker from 'vue-dropdown-datepicker';

export default {
  data() {

    const formConfig = {
      player_dob: {
        id: 'person-birthday',
        name: 'birthday',
        label: 'Your Birthday',
        properties: {
          daySuffixes: false,
          displayFormat: 'ymd',
          minAge: 18,
          minYear: 1940,
          required: true,
        },
        required: true,
        // validatePlayerData,
      },

      minors_date_of_birth: {
          label: 'Minor\'s Date of Birth',
          daySuffixes: false,
          displayFormat: "ymd", 
          minAge: 8,
          maxAge: 18,
          required: true,
      },

    }

    return {
      formConfig,
      formData: {
        player_dob: '',
      },

      gameBayReservationId: '',
      player_first_name:'',
      player_last_name:'',
      player_email:'',
      player_phone:'',
      optionsSelectedNo: [
        { item: 'A', name: 'YES', value: 'A'},
        { item: 'B', name: 'NO', value: 'B'},
      ],
      minorsChecked:'',
      clickedSignature:'',
      showSignaturePad: true ,
      signatureoptions:{
          penColor: "black"
        },
      playerId:'',
      minorsDetail: [
        {
          minors_first_name: "",
          minors_last_name: "",
          minors_date_of_birth: "",
        }
      ],

      validateFirstName:'',
      validateLastName:'',
      validateEmail:'',
      validatePhone:'',
      validateAddMinorButton: '1',
      validatePlayerField: '1',

      validateMinorFirstName:'',
      validateMinorLastName:'',
      validateMinorDob:'',
      validateSubmitWaiver: '',

      minorSelectedDate:'',

      selectedDate: '',

      acceptedCheckBox:'',

      waiverParagraph1: ' BTB Brooklyn 1 LLC (“The Company”) does business as Beat The Bomb and operates Beat The Bomb Brooklyn. ',
        
        waiverParagraph2: ' In consideration of The Company allowing me to participate in Beat The Bomb, I understand and acknowledge that risks and dangers exist due to participation in Beat The Bomb. ',

        waiverParagraph3: 'I confirm I am not experiencing any of the following symptoms of COVID-19: fever or chills, cough, shortness of breath or difficulty breathing, fatigue, Muscle or body aches, headache, new loss of taste or smell, sore throat, congestion or runny nose, nausea or vomiting, diarrhea.', 

        waiverParagraph4: 'I understand that by entering Beat the Bomb’s premises or participating in any activity thereon, I am knowingly and willingly exposing myself to infectious and communicable diseases, including but not limited to severe acute respiratory syndrome coronavirus 2 (commonly known as Covid-19 or coronavirus), and that my presence or participation in any activity on Beat the Bomb’s premises could increase my risk of contracting such diseases.',

        waiverParagraph5:'I understand and acknowledge that my participation in Beat The Bomb (and/or my use of any equipment provided) may result in harm to me (including but not limited to): bodily injury, fractures, eye injury, blindness, heat stroke, heart attack, disease strains, partial and/or total paralysis, death or other ailments that could cause serious disability.',

        waiverParagraph6:'I understand and acknowledge that such injuries could result from (including but not limited to): traversing back and forth across a laser maze that uses Class IIIa 5mW lasers with a 650nm red wavelength; slips, trips, and/or falls in the facility, including but not limited to slippery floors and/or walls (from water, paint, or other substances), that have no handrails; contact with and/or crashing into other participants (whether due to their or your purposeful, reckless, or negligent behavior); contact with and/or crashes with the walls, floors, large metal columns, or doors of any room; defective or negligently maintained or operated equipment in our facility, and/or equipment that is being used in a manner in which it was never intended to be used; getting blasted by high pressure air canons connected to pipes filled with paint, foam and/or soft foam balls.',

        waiverParagraph7: 'I understand that the above risks and dangers (and resultant harm to me) may be caused by the negligence of the owners, employees, officers or agents of The Company; the negligence of other participants or onlookers in the experience, by my own negligence, by accidents, or by forces of nature or other causes. These risks and dangers may arise from foreseeable or unforeseeable causes. By my participation in these activities and/or use of equipment, I hereby assume all risks and dangers and all responsibility for any losses and/or damages, whether caused in whole or in part by the negligence or other conduct of the owners, agents, officers, employees of The Company, or by any other person.',

        waiverParagraph8: 'I, on behalf of myself, my personal representatives and my heirs, executors, administrators, and assigns, hereby voluntarily agree to release, waive, discharge, hold harmless, defend and indemnify The Company and its owners, employees, agents, officers, members, promoters, contractors or business partners, from any and every claims, demands, actions or rights of action, of whatsoever kind or nature, either in law or in equity arising from or by reason of any bodily injury, or personal injuries known or unknown, property damage, wrongful death, loss of services, or otherwise, resulting or to arise out of my participation in Beat The Bomb, whether by negligence or non-negligence or from any and all other incidents of harm and /or ill-will.',

        waiverParagraph9: 'I specifically understand that I am releasing, discharging and waiving any claims or actions that I may have presently or in the future for the negligent acts or conduct by the owners, employees, agents, officers, members, promoters, contractors or business partners of The Company. This waiver also applies to me even if I am not a participant but am instead attending Beat The Bomb as a spectator or bystander. ',

        waiverParagraph10: 'Furthermore I hereby give The Company or any of its assigns or business partners the absolute and irrevocable right and permission with respect to any and all photographs/videos taken of myself, A) to copyright the same in The Company’s or Beat The Bomb’s name or any other name that The Company may select; B) to use, re-use, publish and republish the same in whole or in part, separately or in conjunction with other photographs, in any medium now or hereafter known, including on the Internet and any and all social media channels, and for any purpose whatsoever, including (but not by way of limitation) advertising, promotion and trade; I hereby release and discharge The Company from all and any claims and demands ensuing from or in connection with the use of the photographs/videos, including any and all claims for libel and invasion of privacy. This authorization and release shall inure to the benefit of the legal representatives, licensees, and assigns of The Company.',

        waiverParagraph11: 'Finally, for two years after the expiration of this agreement, I waive any and all rights to build, design, develop, or fund, aid, influence, or direct, anyone else to build, design, or develop, without the express written permission and agreement of The Company, any product or experience, for either commercial or even non-commercial purposes, that is substantially similar in technical design, game mechanics, or experiential elements to Beat The Bomb or aspects of it. This waiver intends to capture all of the constituent Beat The Bomb Missions, with games including but not limited to Hack Attack, Laser Maze, Echo Chamber, Floor Grid, CyberBot, Sequencer, CryptoLaser, Mad Dash, Low Battery or Block Monster. It also includes all of Beat The Bomb’s signature special effects endings, including a paint explosion ending (which concept covers all projectile paint, paint blast, paint canon, or paint bomb experiences) and also a foam ball explosion ending (which concept covers all projectile foam balls combined with a Co2 blast, balls blast, balls cannon or similar experiences). This waiver is meant to provide additional legal protection to The Company over and above any other protections provided by applicable copyright and trademark laws, out of respect for the investment and effort that it took The Company develop the Beat The Bomb product and experience, and despite the fact that Beat The Bomb is marketed to and open to the general public.',

        // waiverParagraph12: 'Furthermore I hereby give Task Force Zero LLC or any of its assigns or business partners the absolute and irrevocable right and permission with respect to any and all photographs/videos taken of myself, a) to copyright the same in Task Force Zero LLC’s or Beat The Bomb’s name or any other name that Task Force Zero LLC may select; b) to use, re-use, publish and republish the same in whole or in part, separately or in conjunction with other photographs, in any medium now or hereafter known, including on the Internet and any and all social media channels, and for any purpose whatsoever, including (but not by way of limitation) advertising, promotion and trade; I hereby release and discharge Task Force Zero LLC from all and any claims and demands ensuing from or in connection with the use of the photographs/videos, including any and all claims for libel and invasion of privacy. This authorization and release shall inure to the benefit of the legal representatives, licensees, and assigns of Task Force Zero LLC. ',

        // waiverParagraph13: 'Finally, for two years after the expiration of this agreement, I waive any and all rights to build, design, develop, or fund, aid, influence, or direct, anyone else to build, design, or develop, without the express written permission and agreement of Task Force Zero LLC, any product or experience, for either commercial or even non-commercial purposes, that is substantially similar in technical design, game mechanics, or experiential elements to Beat The Bomb or aspects of it. This waiver intends to capture all of the constituent Beat The Bomb Missions, with games including but not limited to Hack Attack, Laser Maze, Echo Chamber, Floor Grid, CyberBot, Sequencer, CryptoLaser, Mad Dash, Low Battery or Block Monster. It also includes all of Beat The Bomb’s signature special effects endings, including a paint explosion ending (which concept covers all projectile paint, paint blast, paint canon, or paint bomb experiences) and also a foam ball explosion ending (which concept covers all projectile foam balls combined with a Co2 blast, balls blast, balls cannon or similar experiences). This waiver is meant to provide additional legal protection to Task Force Zero LLC over and above any other protections provided by applicable copyright and trademark laws, out of respect for the investment and effort that it took Task Force Zero LLC develop the Beat The Bomb product and experience, and despite the fact that Beat The Bomb is marketed to and open to the general public.'

    }
  },
  components: {
        // DateDropdown,
        DropdownDatepicker
  },
  computed: {

    stateDateOfBirth () {
      for (var i = 0; i < this.minorsDetail.length; i++) {

        console.log('length'+this.minorsDetail[i].minors_first_name.length);
        
        if(this.minorsDetail[i].minors_first_name != '' && this.minorsDetail[i].minors_last_name.length != '' && this.minorsDetail[i].minors_date_of_birth != '' && this.validateMinorFirstName != '1' && this.validateMinorLastName != '1' && this.validateMinorLastName != '1'){
          console.log('minor contains correct data');
          this.validateAddMinorButton = '0';
        }
        else{
          console.log('minor contains incorrect data');
          this.validateAddMinorButton = '1';
        }
      }
      // return this.formValidated ? !!this.formData.date_of_birth?.length : null
    },

  },
  mounted: function(){
    var currentDate = moment().format('YYYYMMDD');
    // console.log('current date '+currentDate);

    this.findOrCreateReservation();
  },



  methods: {

    validatePlayerData(){

      if(this.player_first_name.length > '0' && this.player_last_name.length > '0' && this.player_phone.length > '9'){
        // console.log('validated player data');
        this.validatePlayerField = '0';

      }
      else{
        // console.log('incorrect player data');
        this.validatePlayerField = '1';
      }
    },

    clickedWaiver(){
      this.$router.push('/');
    },

    valFirstName(){
      var letters = /^[A-Za-z]+$/;
      if(this.player_first_name.match(letters))
      {
        this.validateFirstName = '';
      }
      else
      {
        this.validateFirstName= '1';
      }
    },

    valLastName(){
      var letters = /^[A-Za-z]+$/;
      if(this.player_last_name.match(letters))
      {
        this.validateLastName = '';
      }
      else
      {
        this.validateLastName= '1';
      }
    },

    valPhone(){
      var letters = /^[0-9]+$/;
      if(this.player_phone.match(letters))
      {
        this.validatePhone = '';
      }
      else
      {
        this.validatePhone= '1';
      }
    },

    valEmail(){
      var letters = /^[A-Za-z0-9@._-]+$/;
      if(this.player_email.match(letters))
      {
        this.validateEmail = '';
      }
      else
      {
        this.validateEmail = '1';
      }
    },

    agreedWaiver(){
      this.acceptedCheckBox = '1';
      this.$bvModal.hide('modal-reviewAndAgree');
    },

    valMinorFirstName(index){
      console.log('index was '+index);
      console.log(this.minorsDetail[index].minors_first_name);
      var letters = /^[A-Za-z]+$/;
      if(this.minorsDetail[index].minors_first_name.match(letters))
      {
        this.validateMinorFirstName = '';
        // console.log('correct');
      }
      else
      {
        // console.log('incorrect');
        this.validateMinorFirstName = '1';
      }
    },

    valMinorLastName(index){
      console.log('index was '+index);
      console.log(this.minorsDetail[index].minors_last_name);
      var letters = /^[A-Za-z]+$/;
      if(this.minorsDetail[index].minors_last_name.match(letters))
      {
        this.validateMinorLastName = '';
        console.log('correct');
      }
      else
      {
        console.log('incorrect');
        this.validateMinorLastName = '1';
      }
    },

    deleteMinor: function(event,index){

          console.log('remove minor '+index);
          // console.log(index);

          // var index = this.minorsDetail.indexOf(todo);
          if(this.minorsDetail.length > '1'){
            this.minorsDetail.splice(index, 1);
          }
        },

    reviewAgree(){
      console.log('review agree');
      this.$bvModal.show('modal-reviewAndAgree');
    },

    addMinor(){
      console.log('inside add experience');

      this.minorsDetail.push({
        minors_first_name: '',
        minors_last_name: '',
        minors_date_of_birth: '',
      })
    },

    submitWaiver(){
      console.log('clicked on submit waiver');
      console.log(this.formData.player_dob);

      // this.player_dob = moment(this.selectedDate).format('YYYY-MM-DD');

      // var year = this.selectedDate.substr(6, 4);
      // var month = this.selectedDate.substr(3, 2);
      // var day = this.selectedDate.substr(0, 2);

      // this.player_dob = year+'-'+month+'-'+day;

      if(this.player_first_name != '' && this.player_last_name != '' && this.player_email != ''
      && this.formData.player_dob > '0' && this.acceptedCheckBox > '0'){
          this.postDataToPeopleTable();
      }
      else{
        alert('Missing player detail');
      }
    },

    postDataToPeopleTable(){
      console.log('post player data');

      axios.post(process.env.VUE_APP_PEOPLE+'/find_or_create/email/'+this.player_email+'/first_name/'+this.player_first_name+'/last_name/'+this.player_last_name,{
        date_of_birth: this.player_dob,
        phone: this.player_phone,
        // gender_id: this.gender_id,
        // marketing_consent: this.promotional_item,
        // phone: this.phone,
        // instagram: this.instagram,
        // postal_code: this.zipCodeInput,
        // active: '1',
      })
      .then(response => {
        console.log('posted player detail on people');
        var peopleId = response.data[0].id;
        this.postDataToPlayerTable(peopleId);
      })
      .catch(function (error) {
        console.log(error);
      });
    },

    postDataToPlayerTable(peopleId){

      axios.post(process.env.VUE_APP_PLAYERS+'/find_or_create/'+peopleId,{

      })
      .then(response => {
        console.log('posted detail on player table');
        console.log(response);
        this.playerId = response.data[0].id;

        this.postDataToReservationPeople(peopleId);
      })
      .catch(function (error) {
        console.log(error);
      });

    },

    postDataToReservationPeople(peopleId){

      axios.post(process.env.VUE_APP_RESERVATIONPEOPLE+'/find_or_create/person/'+peopleId+'/reservation/'+this.gameBayReservationId,{
        arrived:'1',
        non_player:'0',
      })
      .then(response => {
        console.log('posted detail on reservation people table');
        console.log(response);

        if(this.minorsChecked == 'no'){
          this.waiverSubmittedPage();
        }
        else{
          this.postDataToPlayerMinor();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    },

    waiverSubmittedPage(){

      this.$bvModal.show('modal-waiverSubmitted');

      // var newUrl = 'http://localhost:8080';

      setTimeout(function(){ 
        window.location.href = process.env.VUE_APP_HOME_PAGE;
      }, 5000);

      // setTimeout(location.reload.bind(location), 9000);

    },

    postDataToPlayerMinor(){
      console.log(this.minorsDetail.length);

      for (var i = 0; i < this.minorsDetail.length; i++) {

        // var year = this.minorSelectedDate[i].substr(6, 4);
        // var month = this.minorSelectedDate[i].substr(3, 2);
        // var day = this.minorSelectedDate[i].substr(0, 2);
        
        axios.post(process.env.VUE_APP_PLAYERMINOR,{
          first_name: this.minorsDetail[i]['minors_first_name'],
          last_name: this.minorsDetail[i]['minors_last_name'],
          // date_of_birth: year+'-'+month+'-'+day,
          date_of_birth: this.minorsDetail[i]['minors_date_of_birth'],
          player_id: this.playerId
        })
        .then(response => {
          
          var playerMinorId = response.data.id;

          /** post minor data to reservation minor **/
          axios.post(process.env.VUE_APP_RESERVATION_MINOR+'/find_or_create/player_minor/'+playerMinorId+'/reservation/'+this.gameBayReservationId,{
            arrived:'1',
            non_player:'0',
          })
          .then(function (response) {
            console.log('added player minor detail on reservation minor table for index '+i);
          })
          .catch(function (error) {
            console.log(error);
          });

        })
        .catch(function (error) {
          console.log(error);
        });

        if(i+1 == this.minorsDetail.length){
          console.log('Added all data for minors');
          this.waiverSubmittedPage();
        }

      }

    },

    minorButtonClicked(value){
      console.log('minor button clicked value was '+value);
      this.minorsChecked=value;
    },

    onBegin() {
          if(this.onBeginValue == '0'){
            this.$refs.signaturePad.$refs.signaturePadCanvas.width = 500;
            this.$refs.signaturePad.$refs.signaturePadCanvas.height = 300;
            this.onBeginValue = '1';
          }
        },

        onEnd() {
          console.log('End signature');
          this.clickedSignature = 1;
          if(this.acceptedCheckBox == '1'){
            // console.log('1');
            this.disabledNextButtonAtLast = false;
          }
        },

    findOrCreateReservation(){
      console.log('inside');
      console.log('create by default gamebay reservation');

    var reservationDateGb = moment().format('YYYY-MM-DD');
    var reservationEmailDateGb = moment().format('YYYYMMDD');
    var firstNameGb = 'Game';
    var lastNameGb = 'bay';
    var phoneNumberGb = '8173601111';
    var emailGb = 'btb_gamebay_'+reservationEmailDateGb+'@gmail.com';
    var teamSizeGb = '6';
    var reservationTimeGb = '10:00:00';

     /** find or create person **/

      axios.post(process.env.VUE_APP_PEOPLE+'/find_or_create/email/'+emailGb+'/first_name/'+firstNameGb+'/last_name/'+lastNameGb,{
        phone: phoneNumberGb
      })
      .then(response => {
        console.log(response.data[0].id); 

        var peopleId = response.data[0].id;

        console.log(process.env.VUE_APP_PLAYERS+'/find_or_create/'+peopleId);

        axios.post(process.env.VUE_APP_PLAYERS+'/find_or_create/'+peopleId,{
             
        })
        .then(response => {
          console.log(response);
          console.log("Create gamebay player id");
        })


        axios.post(process.env.VUE_APP_BOOKERS+'/find_or_create/person/'+peopleId,{
              
        })
        .then(response => {
          console.log("Xola Booker Id response below");
          console.log(response);

          var xolaBookerId = response.data.xola_booker_id;
          var bookerId = response.data.id;

          var xolaOrderId = 'gamebay'+phoneNumberGb;

          axios.post(process.env.VUE_APP_RESERVATIONS+'/find_or_create/booker/'+bookerId,{

          })
          .then(response => {
            console.log("Gamebay xola reservation added");

            var reservationFetchId = response.data[0].id;

            console.log(process.env.VUE_APP_RESERVATIONS+'/'+reservationFetchId);

            axios.put(process.env.VUE_APP_RESERVATIONS+'/'+reservationFetchId,{
              // location_id: process.env.VUE_APP_LOCATION_ID,
              location_id: 2,
              size: teamSizeGb,
              mission_id: 16,
              reservation_for: reservationDateGb+' '+reservationTimeGb,
              battlemode: 0,
              online_reservation: 0,
              xola_order_id: xolaOrderId,
              xola_item_id: xolaOrderId,
              experience_item_id: xolaOrderId
            })
            .then(response => {
              console.log(response);
              console.log('Reservation created for gamebay');

              console.log('reservation id was '+reservationFetchId);
              this.gameBayReservationId = reservationFetchId;

            /** triggers the RELOAD EVENT **/

            })
            .catch(function (error) {
              console.log(error);
            });

          })
          .catch(function (error) {
            console.log(error);
          });

          /** end of find or create reservation **/

        })
        .catch(function (error) {
          console.log(error);
        });
        /** end of find or create booker **/


        })
        .catch(function (error) {
          console.log(error);
        });

  /** end of find or create person **/

    console.log('end of default gamebay reservation');

    },

  },
}
</script>

<style scoped>
  .questionLabel{
    font-size:1rem;
    text-align:left;
    font-weight:bold;
  }
  .inputField{
    align:left;
  }

  .textValidation{
    color:red;
    padding-top:1.5%;
    text-align:left;
    font-style:italic;
  }

  .textValidationMinor{
    color:red;
    padding-top:1.5%;
    text-align:center;
    font-style:italic;
  }

  #signature {
      border: double 3px transparent;
      border-radius: 5px;
      background-image: linear-gradient(white, white),
        radial-gradient(circle at top left, #4bc5e8, #9f6274);
      background-origin: border-box;
      background-clip: content-box, border-box;
      width: auto !important;
      height: 150px !important;
    }

  .circle-checkmark {
    font-family: sans-serif;
    background: lightblue;
    color: white;
    padding: 1px 4px;
    border-radius: 50%;
  }

  ul {
    list-style-type: none;
  }

  li {
    margin: 4px 0;
  }

  li::before {
    font-family: sans-serif;
    content: "✔";
    color: white;
    display: inline-block;
    width: 1em;
    background: lightblue;
    padding-left: 3px;
    border-radius: 50%;
    margin-right: 1em;
  }

  .btnClick{
    background-color:yellow;
  }

</style>

